export const nl = {
    single: 'Enkelvoudig',
    multifocal: 'Multifocaal',
    overview: 'Overzicht',
    glassesPackage: 'Glaspakket',
    frame: 'Zonnebril montuur',
    glassesPrice: 'Brilprijs',
    youPay: 'Totaalprijs',
    free: 'Gratis',
    tooltipText: 'Niet beschikbaar bij dit montuur',
    extraOption: 'Wil je een extra optie toevoegen?',
    readingArea: {
        normal: 'Normaal leesgebied',
        wide: 'Breed leesgebied',
        extraWide: 'Extra breed leesgebied',
        veryWide: 'Zeer breed leesgebied',
    },
    footer: 'Let op: je kunt online een bril bestellen met diverse glaspakketten en glasopties, maar niet alle extra glasopties zijn mogelijk bij een online bestelling. Vragen? <1>Neem contact met ons op</1>.',
};
